import CircularProgress from '@material-ui/core/CircularProgress';
import Button from './Button'
import useServerWait from 'Shared/hooks/useServerWait'

export default function ServerWaitButton ({ className, onClick, children, disabled = false, message = null, saveButton = false, ...rest }) {
  const [saving, setSaving] = useState(false)

  const { doAction, succeeded } = useServerWait({ onClick, saveButton, setSaving, isSaving: saving })

  return <>
    <Button extraClass={className} onClick={doAction} type='button' disabled={disabled || saving || succeeded} {...rest}>
      {succeeded ? '✓ Saved' : <>{children} { saving && <CircularProgress size={20} /> }</>}
    </Button>
    { saving && message && <div><p className='no-margin-bottom error'>{message}</p></div> }
  </>
}
